import { render, staticRenderFns } from "./roster-clever.vue?vue&type=template&id=59e27533&scoped=true&"
import script from "./roster-clever.ts?vue&type=script&lang=ts&"
export * from "./roster-clever.ts?vue&type=script&lang=ts&"
import style0 from "./roster-clever.scss?vue&type=style&index=0&id=59e27533&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e27533",
  null
  
)

export default component.exports